export default __webpack_public_path__ + "static/media/shopify-tag-round.45c95126.svg";